import React from "react";
import Sidebar from "./Sidebar";

export default function Layout({ title, subtitle, actions, children, testId }) {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-[var(--bg)]">
      <Sidebar />
      <main className="flex-1 overflow-y-auto thin-scroll" data-testid={testId || "app-main"}>
        <header className="sticky top-0 z-10 bg-[var(--bg)]/85 backdrop-blur border-b hairline px-4 py-5 sm:px-8">
          <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 className="font-display text-[22px] font-bold tracking-tight">
                {title}
              </h1>
              {subtitle && (
                <p className="text-[13px] text-zinc-500 mt-0.5">{subtitle}</p>
              )}
            </div>
            {actions && (
              <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto sm:justify-end">
                {actions}
              </div>
            )}
          </div>
        </header>
        <div className="px-4 py-8 sm:px-8">{children}</div>
      </main>
    </div>
  );
}
